module.exports = __webpack_public_path__ + "img/Skull toxic.34cd2ac4.png";